import React from "react";
import { appPath, appRoute } from "./appPath";
import { createRoot } from "react-dom/client";

import { LandingPage } from "./landing/LandingPage";
import { FinancialAnalysisPreview } from "./financial-analysis/FinancialAnalysisPreview";
import { PlatformAdminShell } from "./platform-admin/PlatformAdminShell";
import { hasPlatformToken } from "./platform-admin/api";
import { PortalApp } from "./portal/PortalApp";
import { LawyerRegistrationApp } from "./lawyer-registration/LawyerRegistrationApp";
import { LawyerInvitationH5App } from "./lawyer-invitation/LawyerInvitationH5App";
import "./styles.css";

const root = document.querySelector<HTMLElement>("#app");

if (root) {
  const pathname = appRoute();
  const legacyLoginRoute = pathname === "/login";
  const adminNeedsLogin = pathname.startsWith("/admin") && !hasPlatformToken();
  if (legacyLoginRoute || adminNeedsLogin) window.history.replaceState(null, "", appPath("/?login=1"));
  createRoot(root).render(
    <React.StrictMode>
      {pathname === "/lawyer/register" ? <LawyerRegistrationApp /> : pathname === "/lawyer/invite" ? <LawyerInvitationH5App /> : pathname === "/financial-analysis-preview" ? <FinancialAnalysisPreview /> : pathname === "/" || legacyLoginRoute || adminNeedsLogin ? <LandingPage initialLoginOpen={legacyLoginRoute || adminNeedsLogin || new URLSearchParams(window.location.search).get("login") === "1"} /> : pathname.startsWith("/admin") ? <PlatformAdminShell /> : <PortalApp />}
    </React.StrictMode>,
  );
}
